var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-card",
    { attrs: { "body-class": "p-4" } },
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            {
              staticClass: "d-none d-lg-flex justify-content-center",
              attrs: { cols: "1" },
            },
            [_c("div", { staticClass: "step" }, [_vm._v("4")])]
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { cols: "12", md: "11" } },
            [
              _c("p", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("drip-campaigns.stages.editEmails.question"))
                  ),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.$t("drip-campaigns.stages.editEmails.description")
                    ) +
                    " "
                ),
                _c("br"),
                _vm._v(" "),
                _c("b", { staticClass: "text-uppercase" }, [
                  _vm._v(_vm._s(_vm.$tc("drip-campaigns.dripCampaign", 1))),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { staticClass: "slide-up drip-campaign-emails" },
                    [
                      _vm._l(_vm.stages, function (stage, index) {
                        return _c("drip-campaign-single-stage", {
                          key: stage.stageId,
                          attrs: {
                            stage: stage,
                            index: index,
                            "campaign-id": _vm.campaignId,
                            $v: _vm.$v,
                          },
                          on: {
                            "stage-change": function ($event) {
                              return _vm.handleChangeStage($event, index)
                            },
                            "stage-delete": function ($event) {
                              return _vm.handleDeleteStage(index)
                            },
                          },
                        })
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "vertical-line" }, [
                        _c("div", { staticClass: "left-half" }),
                        _vm._v(" "),
                        _c("div", { staticClass: "right-half" }),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "add-new-wrapper" }, [
                        _c("div", { staticClass: "add-new-email" }, [
                          _c(
                            "div",
                            {
                              staticClass: "clickable",
                              on: {
                                click: function ($event) {
                                  return _vm.handleAddStage(false)
                                },
                              },
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "text-regular-gray text-center mb-0",
                                },
                                [
                                  _c(
                                    "a",
                                    { staticClass: "text-primary add-email" },
                                    [_vm._v(_vm._s(_vm.$t("global.words.add")))]
                                  ),
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.$t(
                                          "drip-campaigns.stages.editEmails.anEmail"
                                        )
                                      ) +
                                      "\n                "
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]),
                      ]),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }